import { ReactNode, useLayoutEffect, useState } from 'react';
import { Router as RouterContext } from 'react-router';
import { BrowserHistory } from 'history';

import LastLocationContext from './contexts/lastLocation';

interface RouterProps {
  children: ReactNode;
  history: BrowserHistory;
}

export default function Router({ children, history }: RouterProps) {
  const [state, setState] = useState(function initialState() {
    return { action: history.action, location: history.location };
  });

  useLayoutEffect(
    function effect() {
      history.listen(setState);
    },
    [history],
  );

  return (
    <RouterContext location={state.location} navigationType={state.action} navigator={history}>
      <LastLocationContext>
        {children}
      </LastLocationContext>
    </RouterContext>
  );
}
